import axios from 'axios';
import LocalIP from "../api/LocalIP";
import api from '../interceptors/axios';

export const get = async (url, headers) => {
  try {
    const response = await api.get(LocalIP + url, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const post = async (url, data, headers) => {
  try {
    const response = await api.post(LocalIP + url, data, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const put = async (url, data, headers) => {
  try {
    const response = await api.put(LocalIP + url, data, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const del = async (url, data ,headers) => {
  try {
    const response = await api.delete(LocalIP + url, data, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

